<template>
  <div id="characters-index" class="row-v2">
    <div class="col">
      <div class="col__box">
        <template v-if="characters">
          <div>
            <character-item-component v-for="character in characters.data" :character="character" :key="character.slug"/>
          </div>
          <div class="text-center">
            <paginate-component v-bind="characters" />
          </div>
        </template>
        <loading-component v-else />
      </div>
    </div>
  </div>
</template>
<script>
import CharacterItem from '@/components/character-item';
import Loading from '@/components/loading';
import Paginate from '@/components/paginate';
export default {
  name: 'characters__index',
  components: {
    'character-item-component': CharacterItem,
    'loading-component': Loading,
    'paginate-component': Paginate
  },
  data() {
    return {
      characters: null,
    }
  },
  methods: {
    load() {
      this.characters = null;
      window.api.characters.get(this.$route.query)
        .then((characters) => this.characters = characters);
    },
  },
  created() {
    this.load();
  },
  watch: {
    $route() {
      this.load();
    }
  },
  metaInfo() {
    return {
      title: this.$t("Characters"),
    }
  },
}

</script>
